module.exports = __webpack_public_path__ + "img/ride@3x.1e5edbf7.png";